import React, { FC } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { AnimatedArrow } from 'src/ui/common/atoms/animated-arrow';
import { CardBox } from 'src/ui/white-labels/ocean/layouts/card-box';
import { Tabs } from 'src/ui/white-labels/ocean/molecules/tabs';
import { StyledCardBox } from './styles';

interface IProps {
    selectedTab: string;
    tabs: { tabId: string; tab: string; component: any }[];
}

export const NftActivitiesPage: FC<IProps> = ({ selectedTab, tabs }) => (
    <StyledCardBox isActivities={selectedTab === 'activities'}>
        <CardBox.Heading>
            <Tabs.TabItems tabItems={tabs} />
        </CardBox.Heading>
        <CardBox.Content>
            {tabs.map(({ component, tabId }) => (
                <Tabs.Content tabId={tabId} key={tabId}>
                    {component}
                </Tabs.Content>
            ))}
        </CardBox.Content>
        {isMobileOnly && selectedTab === 'activities' && <AnimatedArrow bottomPosition={70} />}
    </StyledCardBox>
);
